import React, { useState } from "react";

export default function TextArea(props) {
  const [text, setText] = useState("");
  const convertUppercase = () => {
    let uppercase = text.toUpperCase();
    setText(uppercase);
    props.showAlert("Converted to uppercase!", "success");
  };
  const convertLowercase = () => {
    let Lowercase = text.toLowerCase();
    setText(Lowercase);
    props.showAlert("Converted to lowercase!", "success");
  };
  const handleCopy = () => {
    navigator.clipboard.writeText(text); 
    props.showAlert("Copied to Clipboard!", "success");
}
const handleExtraSpaces = () => {
    let newText = text.split(/[ ]+/);
    setText(newText.join(" "));
    props.showAlert("Extra spaces removed!", "success");
}
  const onchangefxn = (event) => {
    setText(event.target.value);
  };
  const clearText = () => {
    setText(" ");
  };
  return (
    <div>
      <div className="container"style={{color: props.modeText==='dark'?'white':'black'}} >
        <h1 className="my-3">Enter Text Here</h1>
        <textarea
          className="position-relative"
          name="text_area"
          id="textarea"
          cols="90"
          rows="10"
          value={text}
          style={{backgroundColor: props.modeText==='dark'? 'Grey': 'white', color:props.modeText=== 'dark'?'white': 'black',cursor:'pointer'}}
          onChange={onchangefxn} placeholder="Enter your text here..."
        ></textarea>
        <div className="my-3 mx-3">
          <button disabled={text.length===0} className="btn btn-primary mx-1 my-1" onClick={convertUppercase}>
            ConvertToUppercase
          </button>
          <button disabled={text.length===0} className="btn btn-primary mx-1 my-1" onClick={convertLowercase}>
            ConvertToLowercase
          </button>
          <button disabled={text.length===0} className="btn btn-primary mx-1 my-1" onClick={clearText}>Clear Text</button>
          <button disabled={text.length===0} className="btn btn-primary mx-1 my-1" onClick={handleCopy}>Copy Text</button>
          <button disabled={text.length===0} className="btn btn-primary mx-1 my-1" onClick={handleExtraSpaces}>Remove Extra Spaces</button>
        </div>
        <div>
        <h1 className="my-3">Text Report</h1>
          <p>{text.split(/\s+/).filter((element)=>{return element.length!==0}).length} words and {text.length} characters</p>
            <p>{0.008 *  text.split(/\s+/).filter((element)=>{return element.length!==0}).length} Minutes read</p>
            <h2>Preview</h2>
            <p>{text.length>0?text:"Nothing to preview!"}</p>
        </div>
      </div>
    </div>
  );
}
